import { Sheet } from '../ui/Sheet';
import { iosInstallGuide } from './installHelp';

/** A bottom sheet that walks the parent through Add to Home Screen for their specific iOS browser (#218). */
export function InstallGuideSheet({ onClose }: { onClose: () => void }) {
  const guide = iosInstallGuide();
  return (
    <Sheet title="Add ClassGuardian to your Home Screen" onClose={onClose}>
      <div className="stack">
        <p className="muted small">In {guide.browser} on iPhone:</p>
        {guide.note && <p className="small">{guide.note}</p>}
        <ol className="install-steps">
          {guide.steps.map((s, i) => (
            <li key={i}>{s}</li>
          ))}
        </ol>
        <p className="muted small">Then open ClassGuardian from the new Home Screen icon to get notifications on your phone.</p>
      </div>
    </Sheet>
  );
}
